import React, { useState, useEffect, useRef } from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { Button } from '@/components/ui/button';
import { Check, FileText, ChevronLeft, ChevronRight, AlertCircle } from 'lucide-react';

// Full intake form structure - Updated February 12, 2026
const FORM_PAGES = [
  {
    id: 'page1',
    pageNum: 1,
    title: ':C.-S.-S.-C.-P.-S.-G.-FLAG OF THE DOCUMENT-CONTRACT-POSTAL-VESSEL-COURT.',
    description: 'We Provide the Correct Claims Assistance for those that are navigating the Judicial System.',
    type: 'info',
    headerText: [
      'We are not Attorneys or Lawyers, though we may act as an Attorney in Fact or the JUDGE in the court of record as the Constitution dictates.',
      'We represent our Claim with you in their Court if you have Joinder and must follow through with an active Case. We Litigate as well as Claim.',
    ],
    websites: ['www.ToddProffit.com', 'www.QLCLLC.com'],
    items: [],
    requiredFields: []
  },
  {
    id: 'page2',
    pageNum: 2,
    title: 'CASE QUALIFICATION',
    description: 'In order to qualify your case for our program please perform the following steps:',
    type: 'info',
    items: [
      { text: '1. Fill out this form: Please be thorough.' },
      { text: '2. Send your ORIGIN case file, original foreclosure notice, criminal complaint, Arrest Warrant, etc....' },
      { text: '3. Pay the Deposit Fee $2,500.00 and send that receipt with your Origin Case filing, email to: AspenLegal@USA.com.' },
      { text: '4. If we can take your case we will notify you within 24 hours of your deposit.' },
      { text: '5. Upon receiving the $2,500.00 in consideration we will have a proposal within 24 hours. If not, we will refund your monies next day.' },
      { text: '   If we can take your case, we will create your Claim within 7-10 business days.' },
      { text: '6. Upon completion of the Claim Package we provide the option of Bonding the Claim for 1/12 of 1% and underwriting fee-$3,000.00.' },
      { text: '   (The Bonding is not required, you can claim without it and work on collections independently.) If you would like to partner it\'s- $1 million in Claim to Bond: Excelsior as the surety, and EPIT for the Bond.' },
      { text: '7. All cases are bonded for damages. We include a Performance Bond, for our performance of $1 million. We collect from the Vassalee(s) after closure.' },
      { text: '8. The Bonding is necessary on or before you file your claim. We underwrite it prior to Claim, Filed on the 100th day of your Claim. If you choose to underwrite it, you can add to the Bond up to the cap. Which is your claims damages total.' },
    ],
    subsections: [
      {
        title: 'Bond Exchange Information',
        items: [
          { text: 'Bonds can be marketed in the private exchange.' },
          { text: 'Go to www.EPITBank.com for videos on the Bond Exchange used to: sell, assign, trade and pool assets.' },
          { text: 'The credibility of the: Vassalees, Insurance, Surety, and Claim determine the value and potential return.' },
          { text: 'Some Bonds 10 cents on the dollar, some are held or used as collateral for developments, or to shore up an SBLC.' },
          { text: 'Some assigned partials for quick returns, some traded for titles, etc. There are various ways to exchange value.' },
        ]
      }
    ],
    requiredFields: []
  },
  {
    id: 'page3',
    pageNum: 3,
    title: 'CONTACT INFORMATION',
    type: 'fields',
    fields: [
      { key: 'name', label: 'Name', type: 'text', required: true },
      { key: 'address', label: 'Address', type: 'textarea', required: true },
      { key: 'email', label: 'Email', type: 'email', required: true },
      { key: 'phone', label: 'Phone', type: 'tel', required: true },
      { key: 'communication_preference', label: 'How you like to communicate: email/phone', type: 'text', required: true },
    ],
    requiredFields: ['name', 'address', 'email', 'phone', 'communication_preference']
  },
  {
    id: 'page4',
    pageNum: 4,
    title: 'Seven Questions',
    description: 'Answers from:',
    type: 'fields',
    fields: [
      { key: 'q1_claimants', label: '1. Who are the Claimants?', type: 'textarea', required: true },
      { key: 'q2_defendants', label: '2. Who are you making claim against- multiple parties-multiple companies?', type: 'textarea', required: true },
      { key: 'q3_desired_outcome', label: '3. Who or what outcome do you want from the case?', type: 'textarea', required: true },
      { key: 'q4_damages', label: '4. What damages do you feel you are owed?', type: 'textarea', required: true },
    ],
    requiredFields: ['q1_claimants', 'q2_defendants', 'q3_desired_outcome', 'q4_damages']
  },
  {
    id: 'page5',
    pageNum: 5,
    title: 'Seven Questions (Continued)',
    type: 'fields',
    fields: [
      { key: 'q5_other_damages', label: '5. What will reconcile the negative consequences?', type: 'textarea', required: true },
      { key: 'q6_impact', label: '6. How has this affected your family and/or business partners?', type: 'textarea', required: true },
      { key: 'q7_simple_story', label: '7. Tell the story to a 6 year old?', type: 'textarea', required: true },
    ],
    seeContractBelow: true,
    requiredFields: ['q5_other_damages', 'q6_impact', 'q7_simple_story']
  },
  {
    id: 'page6',
    pageNum: 6,
    title: 'EPIT PRIVATE BANK & TRUST',
    subtitle: 'INDEPENDENT TRUST FILING 2026',
    subtitle2: 'CLIENT CLAIM SERVICE CONTRACT',
    subtitle3: 'SIMPLE ENGLISH AGREEMENT',
    type: 'contract_header',
    content: {
      partiesTitle: 'Parties',
      serviceProvider: 'Service Provider: Quantum Law Consulting LLC-Ernest-Todd: Proffit, acting as Claimant and Trustee under EPIT Private Bank & Trust.',
      clientField: { key: 'client_name_parties', label: 'Client', type: 'text' },
      authorizationTitle: 'The Client authorizes the Service Provider to prepare, file, and administer lawful claims on their behalf related to:',
      checkboxes: [
        { key: 'auth_foreclosure', label: 'Foreclosure actions' },
        { key: 'auth_false_arrest', label: 'False arrest or incarceration' },
        { key: 'auth_contract_breach', label: 'Contract breaches' },
        { key: 'auth_theft', label: 'Theft of services or materials' },
        { key: 'auth_property', label: 'Property title or possession disputes' },
      ]
    },
    requiredFields: []
  },
  {
    id: 'page7',
    pageNum: 7,
    title: '1. Deposit and Proposal',
    type: 'info',
    items: [
      { text: 'The Client deposits $2,500.00 USD for initial review. Once the seven questions and Affidavit with the origin case/claim documents are received, the Provider will deliver a written proposal for the Claim within 2 business days.' },
      { text: 'If the Provider cannot assist, the deposit is refunded same day.' },
      { text: 'If accepted, the Claim will proceed to filing within 10 business days or as the client dictates thereafter.' },
      { text: '$3,000.00 for bonding payment upon finalizing claim filing. Either $2,500.00+500 for CUSIP or 1/12 of one percent for the additional surety. This will be outlined in the proposal.' },
      { text: 'Note: claims can be processed without bonding, though not recommended.' },
    ],
    subsections: [
      {
        title: '2. Bonded Performance',
        items: [
          { text: 'Each accepted Claim includes a Performance Bond value: $1,000,000 USD, guaranteed by EPIT Private Bank & Trust.' },
          { text: 'If the Provider fails to perform, the bond covers liability.' },
          { text: 'If successful, the Provider becomes a Co-Claimant, entitled to perform enforcement with the Client.' },
        ]
      }
    ],
    requiredFields: []
  },
  {
    id: 'page8',
    pageNum: 8,
    title: '3. Filing Timeline',
    type: 'info',
    items: [
      { text: '1. Notice to Stop and Correct / Complaint Notice (21 days)' },
      { text: '2. Quo Warranto Complaint / Civil Filing (45-day Trust period + 3-day Right of Rescission)-stacked for DOJ/criminal.' },
      { text: '3. Closure and Ledgering: Claim is registered after 69 total days if uncontested. Additional 10 days and 11 days for notice to perfect registered Bonds.' },
      { text: '   The Claim is ledgered under QRIS (Quantum Registration Information System)' },
      { text: '   Filed with EPIT Private Bank & Trust for underwriting and verification.' },
      { text: '   1/12 of 1% monthly. With 10% of the Bond- Surety claimed. Excelsior.' },
    ],
    subsections: [
      {
        title: '4. Settlement',
        items: [
          { text: 'Upon closure:' },
          { text: '• Client receives any cash settlement or property recovery+ Judgement Bond.' },
          { text: '• Provider receives the corresponding Performance Bond.' },
          { text: '• All settlements are recorded and filed with: SEC, IRS, Treasury, and State Departments of Revenue, Department of Justice, financial crimes.' },
        ]
      }
    ],
    requiredFields: []
  },
  {
    id: 'page9',
    pageNum: 9,
    title: '5. Identification and Authorization',
    type: 'info',
    items: [
      { text: 'Each party shall provide:' },
      { text: '• Legal name, address, phone, and email' },
      { text: '• Government-issued ID reference' },
      { text: '• Fingerprint and autograph for recording.' },
      { text: 'Both parties agree by volition to all terms herein by autograph.' },
    ],
    subsections: [
      {
        title: '6. Legal Notice',
        items: [
          { text: 'This agreement is for administrative, and claim purposes only.' },
          { text: 'The Provider is not acting as a licensed attorney, but as a Bonded Claimant and Fiduciary.' },
          { text: 'All filings are administrative civil remedies under commercial and trust law.' },
          { text: 'All claims will be filed with the Department of Justice and the Attorney General of the state for the criminal acts of the parties concerned.' },
          { text: 'Claimant will be authorized as a Whistleblower regarding the criminal claims. As a Whistleblower we have you positioned for % of the punitive damages. This is a separate case from our civil action, in which we are a claimant.' },
        ]
      }
    ],
    requiredFields: []
  },
  {
    id: 'page10',
    pageNum: 10,
    title: 'QUANTUM CONTRACT -TANDEM VERSION',
    type: 'contract',
    paragraphs: [
      'FOR THIS-DOCUMENT-CONTRACT OF THE :EPIT-PRIVATE-BANK-AND-TRUST IS WITH THE KNOWLEDGE OF THE :ERNEST-TODD: PROFFIT-AS-THE-CLAIMANT-TRUSTEE FOR THE CLIENT\'S-CLAIM-AUTHORIZATION-CONTRACT.',
      'FOR THE CONSIDERATION OF THE $2,500.00-USD IS WITH THE COMMENCEMENT OF THE CLAIM\'S-REVIEW-AND-PROPOSAL-WITH A TWO-DAY-TIME-LIMIT-AND A TEN-DAY-PERFORMANCE-PERIOD FOR THE CLAIM-PACKAGE.',
      'FOR THE CLAIM\'S-FILING IS WITH THE NOTICE-TIME OF TWENTY-ONE-DAYS PLUS FORTY-FIVE-DAYS AND THREE-DAYS OF RIGHT-OF-RECESSION = SIXTY-NINE-DAYS FOR THE TRUST-LAW-CLOSURE.',
      'FOR THE PERFORMANCE-FAILURE IS WITH THE LIABILITY-BOND OF ONE-MILLION-DOLLARS, BACKED AND LEDGERED BY THE :EPIT-PRIVATE-BANK-AND-TRUST.',
      'FOR THE PERFORMANCE-SUCCESS IS WITH THE CO-CLAIMANT-AUTHORITY FOR THE CLIENT AND CLAIMANT IN JOINDER WITH THE FEDERAL-FILING-AGENCIES.',
      'FOR THE IDENTIFICATION OF EACH PARTY IS WITH THE NAME, ADDRESS, EMAIL, ID, AUTOGRAPH, AND THUMBPRINT FOR THE LAWFUL-AUTHORITY OF THIS-DOCUMENT-CONTRACT-CLAIM.',
      'FOR THE PURPOSE OF THIS-CONTRACT IS WITH THE PERFORMANCE-OF-THE-CLAIM-SERVICES AND THE PRIVATE-FEDERAL-FILING UNDER THE :EPIT-PRIVATE-BANK-AND-TRUST-LAWFUL-JURISDICTION.',
    ],
    requiredFields: []
  },
  {
    id: 'page11',
    pageNum: 11,
    title: 'Autographs/Authorization',
    type: 'signatures',
    signatureFields: [
      { label: 'Client', key: 'client_signature' },
      { label: 'Ernest-Todd: Proffit (Trustee, Claimant, Witness, Litigator)', key: 'provider_signature', readonly: true },
      { label: 'Witness / Notary', key: 'witness_signature', readonly: true },
    ],
    requiredFields: []
  },
  {
    id: 'page12',
    pageNum: 12,
    title: 'SUMMARY OF PERFORMANCE AND BONDING ALLOCATIONS',
    type: 'summary_table',
    table: {
      rows: [
        { description: 'Deposit Consideration', amount: '$2,500.00', ledger: 'EPIT Intake Ledger' },
        { description: 'Minimum Performance Bond', amount: '$2,500.00+$500-CUSIP or 1/12-1% for $1,000,000.00<', ledger: 'EPIT Trust Bond with underwriting.' },
        { description: 'Refund Guarantee (if declined)', amount: '$2,500.00', ledger: 'Immediate Return' },
        { description: 'Trust Filing Duration', amount: '69 Days', ledger: 'QRIS Record' },
        { description: 'Federal Agencies Filed', amount: 'SEC / IRS / Treasury / State Rev / DOJ / FCU', ledger: 'Confirmed' },
      ]
    },
    footer: '(Prepared and formatted by EPIT Private Bank & Trust – Independent Trust Filing 2026)',
    requiredFields: []
  }
];

// All required fields across all pages
const ALL_REQUIRED_FIELDS = [
  'name', 'address', 'email', 'phone', 'communication_preference',
  'q1_claimants', 'q2_defendants', 'q3_desired_outcome', 'q4_damages',
  'q5_other_damages', 'q6_impact', 'q7_simple_story'
];

export const LiveForm = ({ formData, lastUpdatedField, onFieldChange, onFormComplete }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const fieldRefs = useRef({});
  const formRef = useRef(null);

  const totalPages = FORM_PAGES.length;
  const currentPageData = FORM_PAGES[currentPage];

  // Check if ALL required fields across entire form are filled
  const isFormComplete = () => {
    return ALL_REQUIRED_FIELDS.every(fieldKey => 
      formData[fieldKey] && formData[fieldKey].toString().trim() !== ''
    );
  };

  // Check if current page requirements are met
  const isPageComplete = (pageIndex) => {
    const page = FORM_PAGES[pageIndex];
    if (!page.requiredFields || page.requiredFields.length === 0) return true;
    return page.requiredFields.every(fieldKey => 
      formData[fieldKey] && formData[fieldKey].toString().trim() !== ''
    );
  };

  // Get list of missing fields
  const getMissingFields = () => {
    return ALL_REQUIRED_FIELDS.filter(fieldKey => 
      !formData[fieldKey] || formData[fieldKey].toString().trim() === ''
    );
  };

  // Count filled required fields
  const filledCount = ALL_REQUIRED_FIELDS.filter(k => 
    formData[k] && formData[k].toString().trim() !== ''
  ).length;
  const totalRequired = ALL_REQUIRED_FIELDS.length;
  const progress = (filledCount / totalRequired) * 100;

  // Scroll to top when page changes
  useEffect(() => {
    if (formRef.current) {
      formRef.current.scrollTop = 0;
    }
  }, [currentPage]);

  // Highlight effect
  useEffect(() => {
    if (lastUpdatedField && fieldRefs.current[lastUpdatedField]) {
      fieldRefs.current[lastUpdatedField].scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    }
  }, [lastUpdatedField, formData]);

  const handleFieldChange = (key, value) => {
    if (onFieldChange) {
      onFieldChange({ [key]: value });
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleComplete = () => {
    if (isFormComplete() && onFormComplete) {
      onFormComplete();
    }
  };

  const canProceedToNextPage = isPageComplete(currentPage);
  const isLastPage = currentPage === totalPages - 1;
  const isFirstPage = currentPage === 0;
  const formComplete = isFormComplete();
  const missingFields = getMissingFields();

  return (
    <div className="intake-form flex flex-col h-full" data-testid="live-form">
      {/* Progress Header */}
      <div className="sticky top-0 bg-white z-10 pb-4 border-b mb-4">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <FileText className="w-4 h-4 text-muted-foreground" />
            <span className="text-sm font-medium">
              Page {currentPage + 1} of {totalPages}
            </span>
          </div>
          <div className="flex items-center gap-2">
            {formComplete && (
              <span className="inline-flex items-center gap-1 text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full animate-pulse">
                <Check className="w-3 h-3" />
                Ready!
              </span>
            )}
            <span className={`text-sm font-medium ${formComplete ? 'text-green-600' : 'text-muted-foreground'}`}>
              {filledCount}/{totalRequired} required fields
            </span>
          </div>
        </div>
        
        {/* Animated Progress Bar */}
        <div className="h-3 bg-gray-200 w-full rounded-full overflow-hidden relative">
          <div 
            className={`h-full transition-all duration-500 ease-out ${formComplete ? 'bg-gradient-to-r from-green-400 to-green-500' : 'bg-gradient-to-r from-gray-700 to-black'}`}
            style={{ width: `${progress}%` }}
            data-testid="form-progress-bar"
          />
          {/* Shimmer effect when not complete */}
          {!formComplete && progress > 0 && (
            <div 
              className="absolute top-0 h-full w-20 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"
              style={{ left: `${Math.max(0, progress - 10)}%` }}
            />
          )}
        </div>
        
        {/* Field completion dots */}
        <div className="flex items-center justify-center gap-1 mt-3 flex-wrap">
          {ALL_REQUIRED_FIELDS.map((fieldKey, idx) => {
            const isFilled = formData[fieldKey] && formData[fieldKey].toString().trim() !== '';
            return (
              <div
                key={fieldKey}
                className={`field-progress-dot ${isFilled ? 'filled' : 'empty'}`}
                title={fieldKey.replace(/_/g, ' ').replace(/q\d+/i, 'Q')}
              />
            );
          })}
        </div>
        
        {/* Page dots */}
        <div className="flex items-center justify-center gap-1 mt-2">
          {FORM_PAGES.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentPage(idx)}
              className={`w-2 h-2 rounded-full transition-all ${
                idx === currentPage 
                  ? 'bg-black w-4' 
                  : isPageComplete(idx) 
                    ? 'bg-green-500' 
                    : 'bg-gray-300'
              }`}
              data-testid={`page-dot-${idx}`}
            />
          ))}
        </div>
      </div>

      {/* Scrollable Content */}
      <div ref={formRef} className="flex-1 overflow-y-auto px-1" style={{ minHeight: '350px' }}>
        {/* Page Title */}
        <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
          {currentPageData.title}
        </h3>

        {currentPageData.description && (
          <p className="text-muted-foreground text-sm mb-4">{currentPageData.description}</p>
        )}

        {/* Info type pages */}
        {currentPageData.type === 'info' && (
          <div className="space-y-4">
            {/* Header text for page 1 */}
            {currentPageData.headerText && (
              <div className="space-y-2 text-sm text-gray-600 italic">
                {currentPageData.headerText.map((text, i) => (
                  <p key={i}>{text}</p>
                ))}
              </div>
            )}
            
            {/* Websites */}
            {currentPageData.websites && (
              <div className="flex gap-4 text-sm text-blue-600">
                {currentPageData.websites.map((url, i) => (
                  <a key={i} href={`https://${url}`} target="_blank" rel="noopener noreferrer" className="hover:underline">{url}</a>
                ))}
              </div>
            )}
            
            {currentPageData.items?.length > 0 && (
              <div className="bg-gray-50 p-4 border border-gray-200 space-y-2">
                {currentPageData.items.map((item, i) => (
                  <p key={i} className="text-sm">{item.text}</p>
                ))}
              </div>
            )}
            {currentPageData.subsections?.map((sub, i) => (
              <div key={i} className="bg-white p-4 border border-gray-200">
                <h4 className="font-semibold mb-3">{sub.title}</h4>
                {sub.items?.map((item, j) => (
                  <p key={j} className="text-sm mb-1">{item.text}</p>
                ))}
              </div>
            ))}
          </div>
        )}

        {/* Fields type pages */}
        {currentPageData.type === 'fields' && (
          <div className="space-y-4">
            {currentPageData.fields?.map((field) => (
              <FormField
                key={field.key}
                field={field}
                value={formData[field.key] || ''}
                isHighlighted={lastUpdatedField === field.key}
                isFilled={!!formData[field.key]}
                onChange={(value) => handleFieldChange(field.key, value)}
                ref={el => fieldRefs.current[field.key] = el}
              />
            ))}
            {currentPageData.seeContractBelow && (
              <div className="mt-4 text-center text-sm font-semibold text-gray-600 border-t pt-4">
                SEE CONTRACT BELOW:
              </div>
            )}
          </div>
        )}

        {/* Contract Header type (EPIT Private Bank page) */}
        {currentPageData.type === 'contract_header' && currentPageData.content && (
          <div className="space-y-4">
            {currentPageData.subtitle && (
              <p className="text-center text-sm font-semibold">{currentPageData.subtitle}</p>
            )}
            {currentPageData.subtitle2 && (
              <p className="text-center text-lg font-bold">{currentPageData.subtitle2}</p>
            )}
            {currentPageData.subtitle3 && (
              <p className="text-center text-sm font-semibold underline">{currentPageData.subtitle3}</p>
            )}
            
            <div className="bg-gray-50 p-4 border border-gray-200 mt-4">
              <h4 className="font-bold mb-3">{currentPageData.content.partiesTitle}</h4>
              <p className="text-sm mb-2">{currentPageData.content.serviceProvider}</p>
              <div className="mt-4">
                <Label>{currentPageData.content.clientField.label}: _______________</Label>
                <Input 
                  value={formData[currentPageData.content.clientField.key] || formData.name || ''}
                  onChange={(e) => handleFieldChange(currentPageData.content.clientField.key, e.target.value)}
                  className="mt-1 rounded-none"
                  placeholder="Your name (auto-filled from contact info)"
                />
              </div>
            </div>
            
            <div className="space-y-3">
              <p className="text-sm font-medium">{currentPageData.content.authorizationTitle}</p>
              {currentPageData.content.checkboxes?.map((cb) => (
                <div key={cb.key} className="flex items-center gap-3 p-2 border border-gray-100 hover:bg-gray-50">
                  <Checkbox 
                    id={cb.key}
                    checked={formData[cb.key] || false}
                    onCheckedChange={(checked) => handleFieldChange(cb.key, checked)}
                  />
                  <Label htmlFor={cb.key} className="text-sm cursor-pointer flex-1">{cb.label}</Label>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Mixed type pages (legacy support) */}
        {currentPageData.type === 'mixed' && currentPageData.content && (
          <div className="space-y-4">
            <div className="bg-gray-50 p-4 border border-gray-200">
              <p className="text-sm mb-2">
                <strong>Service Provider:</strong> {currentPageData.content.serviceProvider}
              </p>
              <div className="mt-4">
                <Label>{currentPageData.content.clientField.label}</Label>
                <Input 
                  value={formData[currentPageData.content.clientField.key] || formData.name || ''}
                  onChange={(e) => handleFieldChange(currentPageData.content.clientField.key, e.target.value)}
                  className="mt-1 rounded-none"
                  placeholder="Your name (auto-filled from contact info)"
                />
              </div>
            </div>
            
            <div className="space-y-3">
              <p className="text-sm font-medium">{currentPageData.content.authorizationTitle}</p>
              {currentPageData.content.checkboxes?.map((cb) => (
                <div key={cb.key} className="flex items-center gap-3 p-2 border border-gray-100 hover:bg-gray-50">
                  <Checkbox 
                    id={cb.key}
                    checked={formData[cb.key] || false}
                    onCheckedChange={(checked) => handleFieldChange(cb.key, checked)}
                  />
                  <Label htmlFor={cb.key} className="text-sm cursor-pointer flex-1">{cb.label}</Label>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Contract type pages */}
        {currentPageData.type === 'contract' && (
          <div className="bg-gray-50 p-4 border border-gray-200 space-y-4 font-mono text-xs leading-relaxed">
            {currentPageData.paragraphs?.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        )}

        {/* Summary Table type */}
        {currentPageData.type === 'summary_table' && (
          <div className="space-y-4">
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-2 text-left">Description</th>
                  <th className="border border-gray-300 p-2 text-left">Amount (USD)</th>
                  <th className="border border-gray-300 p-2 text-left">Ledger</th>
                </tr>
              </thead>
              <tbody>
                {currentPageData.table?.rows.map((row, i) => (
                  <tr key={i}>
                    <td className="border border-gray-300 p-2">{row.description}</td>
                    <td className="border border-gray-300 p-2">{row.amount}</td>
                    <td className="border border-gray-300 p-2">{row.ledger}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {currentPageData.footer && (
              <p className="text-xs text-center text-gray-500 italic">{currentPageData.footer}</p>
            )}
          </div>
        )}

        {/* Signatures type pages */}
        {currentPageData.type === 'signatures' && (
          <div className="space-y-6">
            {!formComplete && (
              <div className="bg-red-50 p-4 border border-red-200 text-red-800">
                <div className="flex items-start gap-2">
                  <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="font-medium">Please complete all required fields before proceeding</p>
                    <p className="text-sm mt-1">Missing: {missingFields.length} field(s)</p>
                    <ul className="text-xs mt-2 list-disc list-inside">
                      {missingFields.slice(0, 5).map(f => (
                        <li key={f}>{f.replace(/_/g, ' ').replace(/q\d+/i, 'Question')}</li>
                      ))}
                      {missingFields.length > 5 && <li>...and {missingFields.length - 5} more</li>}
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {formComplete && (
              <div className="bg-green-50 p-4 border border-green-200 text-green-800">
                <div className="flex items-center gap-2">
                  <Check className="w-5 h-5" />
                  <p className="font-medium">All required fields completed! You can proceed to sign.</p>
                </div>
              </div>
            )}
            
            {currentPageData.table && (
              <div>
                <h4 className="font-semibold mb-4">{currentPageData.table.title}</h4>
                <div className="border border-gray-200 overflow-hidden text-sm">
                  <div className="grid grid-cols-3 bg-gray-100 font-medium">
                    <div className="p-3 border-r border-gray-200">Description</div>
                    <div className="p-3 border-r border-gray-200">Amount</div>
                    <div className="p-3">Ledger</div>
                  </div>
                  {currentPageData.table.rows?.map((row, i) => (
                    <div key={i} className="grid grid-cols-3 border-t border-gray-200">
                      <div className="p-3 border-r border-gray-200">{row.description}</div>
                      <div className="p-3 border-r border-gray-200">{row.amount}</div>
                      <div className="p-3">{row.ledger}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Navigation Buttons */}
      <div className="sticky bottom-0 bg-white pt-4 border-t mt-4">
        <div className="flex items-center justify-between gap-4">
          <Button
            variant="outline"
            onClick={goToPrevPage}
            disabled={isFirstPage}
            className="rounded-none flex-1"
            data-testid="prev-page-btn"
          >
            <ChevronLeft className="w-4 h-4 mr-2" />
            Previous
          </Button>
          
          {isLastPage ? (
            <Button
              onClick={handleComplete}
              disabled={!formComplete}
              className={`rounded-none flex-1 ${
                formComplete 
                  ? 'bg-green-600 hover:bg-green-700' 
                  : 'bg-gray-400'
              } text-white`}
              data-testid="complete-form-btn"
            >
              Complete Form
              <Check className="w-4 h-4 ml-2" />
            </Button>
          ) : (
            <Button
              onClick={goToNextPage}
              disabled={!canProceedToNextPage}
              className="rounded-none flex-1 bg-black hover:bg-black/90 text-white"
              data-testid="next-page-btn"
            >
              Next
              <ChevronRight className="w-4 h-4 ml-2" />
            </Button>
          )}
        </div>
        
        {!canProceedToNextPage && currentPageData.requiredFields?.length > 0 && (
          <p className="text-xs text-red-500 text-center mt-2">
            Please fill in all required fields on this page to continue
          </p>
        )}
      </div>
    </div>
  );
};

const FormField = React.forwardRef(({ field, value, isHighlighted, isFilled, onChange, wasJustFilled }, ref) => {
  const InputComponent = field.type === 'textarea' ? Textarea : Input;
  const [showBurst, setShowBurst] = useState(false);
  const prevFilledRef = useRef(isFilled);
  
  // Detect when field transitions from empty to filled
  useEffect(() => {
    if (isFilled && !prevFilledRef.current) {
      // Field just got filled - trigger burst animation
      setShowBurst(true);
      const timer = setTimeout(() => setShowBurst(false), 500);
      return () => clearTimeout(timer);
    }
    prevFilledRef.current = isFilled;
  }, [isFilled]);
  
  return (
    <div 
      ref={ref}
      className={`form-field transition-all duration-300 rounded-lg p-3 ${isFilled ? 'filled' : ''} ${isHighlighted ? 'highlight' : ''} ${wasJustFilled ? 'just-filled' : ''}`}
      data-testid={`form-field-${field.key}`}
    >
      <Label className="flex items-center gap-2 mb-2">
        <span className="flex-1">{field.label}</span>
        {field.required && !isFilled && <span className="text-red-500 text-xs">*Required</span>}
        {isFilled && (
          <span className="checkmark-container">
            {showBurst && <span className="checkmark-burst" />}
            <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-green-500 ${showBurst ? 'checkmark-animated' : ''}`}>
              <Check className="w-3 h-3 text-white" strokeWidth={3} />
            </span>
          </span>
        )}
      </Label>
      <InputComponent
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={`Enter ${field.label.toLowerCase().replace(/question \d+: /i, '')}...`}
        className={`rounded-none transition-all duration-300 ${
          isFilled ? 'bg-green-50 border-green-500' : 'bg-white'
        } ${isHighlighted ? 'ring-2 ring-black ring-offset-2' : ''}`}
        rows={field.type === 'textarea' ? 4 : undefined}
        type={field.type === 'textarea' ? undefined : field.type}
        data-testid={`form-input-${field.key}`}
      />
    </div>
  );
});

FormField.displayName = 'FormField';

export default LiveForm;
